<template>
    <div class="pip-player-control-wrapper">
        <div class="pip-controls-inner">
            <div class="fileName" v-text="playFileName"></div>
            <PlayerPlaylist ref="playlistRef"
                            @play="playIndex" />
            <div class="play-control-row"
                 v-if="playlist.length > 1">

                <button class="player-btn"
                        @click="playPrev">
                    ⏮ 이전
                </button>

                <button class="player-btn"
                        @click="playNext">
                    다음 ⏭
                </button>

            </div>

            <div class="utility-control-row">

                <button class="showPlaylist-btn"
                        @click="togglePlaylist">
                    ☰
                </button>

                <button class="subtitle-btn"
                        @click="toggleSubtitle">
                    자막
                </button>

            </div>

            <SubtitlePanel ref="subtitlePanelRef" />

        </div>
    </div>
</template>

<script setup>
    import { ref, computed } from "vue";
    import { useStore } from "vuex";

    import PlayerPlaylist from "./PlayerPlaylist.vue";
    import SubtitlePanel from "./SubtitlePanel.vue";
    const playlistRef = ref(null);
    const subtitlePanelRef = ref(null);
    const store = useStore();

    const playlist = computed(() => store.state.media.playlist);
    const currentMediaFile = computed(() => store.state.media.mediaFile);
    const playFileName = computed(() => currentMediaFile.value?.name || "");

    async function playPrev() {
        await store.dispatch("media/playPrev");
    }

    async function playNext() {
        await store.dispatch("media/playNext");
    }

    async function playIndex(index) {
        await store.dispatch("media/playIndex", index);
    }

    function togglePlaylist() {
        playlistRef.value?.toggle();
    }

    function toggleSubtitle() {
        subtitlePanelRef.value?.toggle();
    }
</script>

<style scoped>
    .pip-root {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .pip-video {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
    }

        .pip-video video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

    .pip-player {
        position: absolute;
        inset: 0;
        z-index: 10000;
        pointer-events: none;
    }

    .fileName {
        position: absolute;
        display: flex;
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
        max-width: 70%;
        color: rgb(255, 255, 255);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background: rgba(0, 0, 0, 0.6);
        padding: 2px 6px;
        border-radius: 4px;
        z-index: 1;
        pointer-events: none;
    }

        .pip-player.show {
            opacity: 1;
            pointer-events: auto;
        }

    .play-control-row {
        position: absolute;
        left: 12px;
        bottom: 30px;
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .utility-control-row {
        position: absolute;
        right: 12px;
        bottom: 30px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-end;
    }
</style>